import { Component, inject } from '@angular/core';
import { liveStatusTranslationKey } from '../../core/live-updates/live-update.models';
import { LiveUpdateService } from '../../core/live-updates/live-update.service';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { InventoryPageHintComponent } from './inventory-page-hint.component';
import { InventoryMovementOperationsPanelComponent } from './inventory-movement-operations-panel.component';

@Component({
  standalone: true,
  selector: 'ain-inventory-movements',
  imports: [AinPageComponent, InventoryPageHintComponent, InventoryMovementOperationsPanelComponent],
  template: `
    <ain-page [title]="t('catalog.movements.title')" [description]="t('catalog.movements.description')">
      <ain-inventory-page-hint pageKey="movements" />
      <span class="live-status" [class]="liveUpdateService.connectionState()">{{ t(liveStatusTranslationKey(liveUpdateService.connectionState())) }}</span>
      <ain-inventory-movement-operations-panel />
    </ain-page>
  `,
  styles: [`
    .live-status { font-size:0.8rem;color:#6b7280;display:block;margin-bottom:8px; }
    .live-status.connected{color:#166534;}
  `]
})
export class InventoryMovementsComponent {
  readonly liveUpdateService = inject(LiveUpdateService);
  private readonly localization = inject(LocalizationService);
  readonly liveStatusTranslationKey = liveStatusTranslationKey;

  t(key: string): string {
    return this.localization.translate(key);
  }
}
